import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpParams,
  HttpRequest,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";

export class WebInterceptor implements HttpInterceptor {
  private readonly REQUESTER_APP = "RequesterApp";
  private readonly INCLUDE_REQUESTOR = "includeRequestor";

  constructor() {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    const isRequestToCotecnaEyeBackend = req.url.startsWith(
      environment.webApiUrl,
    );
    if (isRequestToCotecnaEyeBackend) {
      let params = new HttpParams();

      if (
        req.params.has(this.INCLUDE_REQUESTOR) === true &&
        req.headers.has(this.REQUESTER_APP) === true
      ) {
        return next.handle(req);
      }

      params = req.params.append(this.INCLUDE_REQUESTOR, "true");
      req = req.clone({
        params: params,
        headers: req.headers.append(this.REQUESTER_APP, "web"),
      });
    }

    return next.handle(req);
  }
}
